import {HandlerList} from "../../../infrastructure/handlers/handler-list";
import {TimingHandler} from "../../../infrastructure/handlers/timing-handler";
import {NewSearchWidgetChangeQueryHandler} from "./new-search-widget.change-query.handler";
import {NewSearchWidgetSportTypesFetchHandler} from "./new-search-widget.sport-types.fetch-handler";
import {NewSearchWidgetSportTypeClickHandler} from "./new-search-widget.sport-type-click.handler";
import {SearchClickHandler} from "../../../core/handlers/search-click.handler";
import {NewSearchWidgetTopCompetitionsFetchHandler} from "./popular-entities/new-search-widget.top-competitions.fetch-handler";
import {NewSearchWidgetTopCompetitorsFetchHandler} from "./popular-entities/new-search-widget.top-competitors.fetch-handler";
import {NewSearchWidgetTopAthletesFetchHandler} from "./popular-entities/new-search-widget.top-athletes.fetch-handler";
import {NewSearchWidgetRecentSearchesFetchHandler} from "./new-search-widget.recent-searches.fetch-handler";
import {NewSearchWidgetEntityClickHandler} from "./new-search-widget.entity-click.handler";
import {SearchStorageEntityHandler} from "../../../core/handlers/search.storage-entity.handler";
import {EntityClickEventHandler} from "../../../core/handlers/entity-click-event.handler";
import {NewSearchWidgetClearHandler} from "./clear-recent/new-search-widget.clear-handler";
import {NewSearchWidgetClearEventHandler} from "./clear-recent/new-search-widget.clear-event.handler";
import {NewSearchWidgetSearchFetchHandler} from "./new-search-widget.search-fetch-handler";
import {NewSearchWidgetSportTypeMenuClickHandler} from "./new-search-widget.sport-type-menu-click.handler";
import {NewSearchWidgetSearchPopulateDataHandler} from "./new-search-widget.search-populate-data.handler";
import {NewSearchWidgetSearchResetHandler} from "./new-search-widget.search-reset.handler";
import {NewSearchWidgetSeeAllClickHandler} from "./new-search-widget.see-all-click.handler";
import {NewSearchWidgetSearchClickEventHandler} from "./analytics/new-search-widget.search-click-event.handler";
import {NewSearchWidgetSportTypeClickEventHandler} from "./analytics/new-search-widget.sport-type.click-event.handler";
import {SearchEndedEventHandler} from "../../../core/handlers/search-ended-event.handler";
import {NewSearchWidgetSeeAllClickEventHandler} from "./analytics/new-search-widget.see-all-click-event.handler";
import {NewSearchWidgetQueryNextActionEventHandler} from "./analytics/new-search-widget.query.next-action-event.handler";
import {NewSearchWidgetTabClickHandler} from "./new-search-widget.tab-click.handler";

export class NewSearchWidgetHandlers extends HandlerList {
  static injectables = [
    NewSearchWidgetSearchFetchHandler,
    NewSearchWidgetSearchPopulateDataHandler,
    NewSearchWidgetSearchResetHandler,
    NewSearchWidgetSportTypesFetchHandler,
    NewSearchWidgetRecentSearchesFetchHandler,
    NewSearchWidgetSportTypeClickHandler,
    NewSearchWidgetSportTypeMenuClickHandler,
    NewSearchWidgetChangeQueryHandler,
    NewSearchWidgetTopCompetitionsFetchHandler,
    NewSearchWidgetTopCompetitorsFetchHandler,
    NewSearchWidgetTopAthletesFetchHandler,
    NewSearchWidgetEntityClickHandler,
    NewSearchWidgetTabClickHandler,
    NewSearchWidgetClearHandler,
    NewSearchWidgetClearEventHandler,
    NewSearchWidgetSeeAllClickHandler,
    NewSearchWidgetSearchClickEventHandler,
    NewSearchWidgetSportTypeClickEventHandler,
    NewSearchWidgetSeeAllClickEventHandler,
    NewSearchWidgetQueryNextActionEventHandler,
    SearchStorageEntityHandler,
    EntityClickEventHandler,
    SearchClickHandler,
    SearchEndedEventHandler,
    TimingHandler
  ];

  constructor (
    newSearchWidgetSearchFetchHandler: NewSearchWidgetSearchFetchHandler,
    newSearchWidgetSearchPopulateDataHandler: NewSearchWidgetSearchPopulateDataHandler,
    newSearchWidgetSearchResetHandler: NewSearchWidgetSearchResetHandler,
    newSearchWidgetSportTypesFetchHandler: NewSearchWidgetSportTypesFetchHandler,
    newSearchWidgetRecentSearchesFetchHandler: NewSearchWidgetRecentSearchesFetchHandler,
    newSearchWidgetSportTypeClickHandler: NewSearchWidgetSportTypeClickHandler,
    newSearchWidgetSportTypeMenuClickHandler: NewSearchWidgetSportTypeMenuClickHandler,
    newSearchWidgetChangeQueryHandler: NewSearchWidgetChangeQueryHandler,
    newSearchWidgetTopCompetitionsFetchHandler: NewSearchWidgetTopCompetitionsFetchHandler,
    newSearchWidgetTopCompetitorsFetchHandler: NewSearchWidgetTopCompetitorsFetchHandler,
    newSearchWidgetTopAthletesFetchHandler: NewSearchWidgetTopAthletesFetchHandler,
    newSearchWidgetEntityClickHandler: NewSearchWidgetEntityClickHandler,
    newSearchWidgetTabClickHandler: NewSearchWidgetTabClickHandler,
    newSearchWidgetClearHandler: NewSearchWidgetClearHandler,
    newSearchWidgetClearEventHandler: NewSearchWidgetClearEventHandler,
    newSearchWidgetSeeAllClickHandler: NewSearchWidgetSeeAllClickHandler,
    newSearchWidgetSearchClickEventHandler: NewSearchWidgetSearchClickEventHandler,
    newSearchWidgetSportTypeClickEventHandler: NewSearchWidgetSportTypeClickEventHandler,
    newSearchWidgetSeeAllClickEventHandler: NewSearchWidgetSeeAllClickEventHandler,
    newSearchWidgetQueryNextActionEventHandler: NewSearchWidgetQueryNextActionEventHandler,
    searchStorageEntityHandler: SearchStorageEntityHandler,
    entityClickEventHandler: EntityClickEventHandler,
    searchClickHandler: SearchClickHandler,
    searchEndedEventHandler: SearchEndedEventHandler,
    timingHandler: TimingHandler
  ) {
    super();

    [
      newSearchWidgetSearchFetchHandler,
      newSearchWidgetSearchPopulateDataHandler,
      newSearchWidgetSearchResetHandler,
      newSearchWidgetSportTypesFetchHandler,
      newSearchWidgetRecentSearchesFetchHandler,
      newSearchWidgetSportTypeClickHandler,
      newSearchWidgetSportTypeMenuClickHandler,
      newSearchWidgetChangeQueryHandler,
      newSearchWidgetTopCompetitionsFetchHandler,
      newSearchWidgetTopCompetitorsFetchHandler,
      newSearchWidgetTopAthletesFetchHandler,
      newSearchWidgetEntityClickHandler,
      newSearchWidgetTabClickHandler,
      newSearchWidgetClearHandler,
      newSearchWidgetClearEventHandler,
      newSearchWidgetSeeAllClickHandler,
      newSearchWidgetSearchClickEventHandler,
      newSearchWidgetSportTypeClickEventHandler,
      newSearchWidgetSeeAllClickEventHandler,
      newSearchWidgetQueryNextActionEventHandler,
      searchStorageEntityHandler,
      entityClickEventHandler,
      searchClickHandler,
      searchEndedEventHandler,
      timingHandler
    ].forEach(handler => this.add(handler));
  }
}
